import StoreInfoBox from '@components/storelocator/StoreInfoBox';
import React from 'react';
import { useTranslation } from 'react-i18next';
const ProductBoutiqueStore = (props) => {
    const { t } = useTranslation();
    const handlePress = (e) => {
        e.preventDefault();
        props.onReservePress();
        document.querySelector('.product-reserve__main').classList.add('zoom-product');
        window.loggedin && document.querySelector('.product-reserve__detail').classList.add('zoom-product');
    };
    return (React.createElement("div", { className: "product-reserve-store" },
        React.createElement("div", { className: "product-reserve-store__content" },
            React.createElement("div", { className: "product-reserve-store__content__name" },
                React.createElement("span", null,
                    props.index,
                    ". ",
                    props.store.name),
                props.store.distance && React.createElement("span", { className: "store-distance" }, props.store.distance)),
            React.createElement(StoreInfoBox, { store: props.store }),
            window.country === 'RU' && React.createElement("p", { className: "tax-disclaimer" }, t('store.clickAndReserve.taxdisclaimer')),
            React.createElement("button", { onClick: handlePress, className: "button button--secondary button--reserve" },
                React.createElement("span", null, t('button.reserveitem'))))));
};
export default ProductBoutiqueStore;
